import { render, staticRenderFns } from "./blockIpsModal.vue?vue&type=template&id=4d1d10e4&scoped=true"
import script from "./blockIpsModal.vue?vue&type=script&lang=js"
export * from "./blockIpsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1d10e4",
  null
  
)

export default component.exports